export const getPercentageGetter = (numberOfRespondents: number) => {
  return (score: number) => {
    if (numberOfRespondents === 0) {
      return 0;
    }
    return 100 * (score / numberOfRespondents);
  };
};
